import { Link } from "react-router-dom";

function Title() {
    return (
        <h1 className="pt-2 text-center"><Link id="heading" to="/">Kilo</Link></h1>
    );
}

export default Title;
